

// ********************** Google Search API Call From Backend  ***********************

import { Directive, ElementRef, EventEmitter, Output, Input, OnChanges, HostListener, Renderer2 } from '@angular/core';
import { UserCommonService } from '../services/user-common.service';
import { UiService } from '../services/ui.service';
import { AppSettings } from '../app.settings';
import { StorageService } from '../services/storage.service';
declare const google: any;

@Directive({
  selector: '[appSearchLocation]',
})
export class SearchLocationDirective implements OnChanges {
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @Input() onlyCity = false;
  private _el: HTMLElement;
  private dropdown: HTMLElement;
  private autocompleteResults: any[] = [];
  tenantInfo: any;
  userEnteredInput: string;
  imgPath = '../../../../assets/images/temp/grey-marker.svg';


  constructor(
    private el: ElementRef,
    private userCommonService: UserCommonService,
    private renderer: Renderer2,
    private uiService: UiService,
    private storageService: StorageService
  ) {
    this.tenantInfo = this.storageService.getItem(AppSettings.TENANT_INFO);
    this._el = el.nativeElement;
    this._el.setAttribute('autocomplete', 'off');
    this._el.onpaste = (e) => e.preventDefault();
    this.createDropdown();
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = (event.target as HTMLInputElement).value;
    this.userEnteredInput = input;
    if (input.length % 3 === 0 && input) {
      this.getAutocompleteSuggestions(input);
    } else if (!input) {
      this.clearDropdown();
    }
  }

  // @HostListener('keydown', ['$event'])
  // onKeyDown(event: KeyboardEvent): void {
  //   const input = (event.target as HTMLInputElement).value;
  //   if (event.key === 'Enter') {
  //     this.getAutocompleteSuggestions(input);
  //   }
  // }

  @HostListener('document:click', ['$event'])
  onClick(event: Event): void {
    const isInputFocused = this._el.contains(event.target as Node);
    const isDropdownFocused = this.dropdown.contains(event.target as Node);

    if (!isInputFocused && !isDropdownFocused) {
      this.hideDropdown();
    } else if(isInputFocused){
      this.showDropdown();
    }
  }

  getAutocompleteSuggestions(input): void {
    // let location;
    // if (this.tenantInfo !== undefined && this.tenantInfo !== null) {
    //   location = `${this.tenantInfo?.latitude},${this.tenantInfo?.longitude}`;
    // }
    // restrictionLocationLatitude: this.tenantInfo?.latitude,
    //   restrictionLocationLongitude:this.tenantInfo?.longitude,
    const data = {
      input:this.userEnteredInput,
      radiusInMeter:''
    }

    this.userCommonService.getGoogleMapAutoComplete(data).subscribe(
      (response: any) => {
        if (response.suggestions.length) {
          this.autocompleteResults = response.suggestions;
          this.populateDropdown();
        } else if(response.status === 'OVER_QUERY_LIMIT' && response.error_message){
          this.uiService.showMessage(response.error_message, AppSettings.MESSAGE_TYPE.ERROR)
        } else{
          this.clearDropdown();
        }
      },
      (error) => {
        this.clearDropdown();
      }
    );
  }

  hideDropdown(){
    this.renderer.setStyle(this.dropdown, 'display', 'none');
  }

  showDropdown(){
    this.renderer.setStyle(this.dropdown, 'display', 'block');
  }

  createDropdown(): void {
    this.dropdown = this.renderer.createElement('div');
    this.renderer.addClass(this.dropdown, 'places-dropdown-container');
    this.renderer.appendChild(document.body, this.dropdown);
    this.positionDropdown();
  }

  positionDropdown(): void {
    const rect = this._el.getBoundingClientRect();
    this.renderer.setStyle(this.dropdown, 'top', rect.bottom + 'px');
    this.renderer.setStyle(this.dropdown, 'left', rect.left + 'px');
  }

  populateDropdown(): void {
    const parent = this._el.parentNode;
    const children = parent.children;
    if(children.length > 1){
      parent.removeChild(children[1]);
    }

    const parentElement = this.renderer.parentNode(this._el);
    this.renderer.setStyle(parentElement, 'position', 'relative');

    const dropdownContainer = this.renderer.createElement('div');
    this.renderer.addClass(this.dropdown, 'places-dropdown-container');

    this.renderer.insertBefore(this._el.parentNode, dropdownContainer, this._el.nextSibling);

    this.autocompleteResults.forEach((result) => {
      // console.log(result)
      const placePrediction = result.placePrediction;
      // console.log(placePrediction)
      const description = placePrediction?.text?.text || '';
      // console.log(description)
      const placeId = placePrediction?.placeId || '';
      // const option = this.renderer.createElement('div');
      // this.renderer.setStyle(option, 'padding', '8px');
      // this.renderer.setStyle(option, 'cursor', 'pointer');
      // this.renderer.setStyle(option, 'width', `${this._el.offsetWidth}px`);
      // this.renderer.listen(option, 'click', () => this.onOptionSelected(description));
      // const text = this.renderer.createText(result.placePrediction?.text?.text);
      // console.log(text)
      // this.renderer.appendChild(option, text);
      // this.renderer.appendChild(dropdownContainer, option);
      this.renderer.addClass(dropdownContainer, 'places-dropdown')

      this.renderer.insertBefore(this._el.parentNode, dropdownContainer, this._el.nextSibling);

      const options = this.renderer.createElement('div');
      const pin = this.renderer.createElement('img');
      this.renderer.setAttribute(pin, 'src', this.imgPath);
      this.renderer.addClass(pin, 'places-marker');
      this.renderer.appendChild(options, pin);
      this.renderer.setAttribute(options, 'title', result.placePrediction?.text?.text);
      this.renderer.addClass(options, 'places-dropdown-option');
      this.renderer.setStyle(options, 'width', `${this._el.offsetWidth}px`);
      this.renderer.listen(options, 'click', () => this.onOptionSelected({description,placeId}));
      const mainText = this.renderer.createText(result.placePrediction.structuredFormat.mainText.text);
      const secondaryText = this.renderer.createText(result.placePrediction.structuredFormat.secondaryText.text);
      const span1 = this.renderer.createElement('span');
      this.renderer.addClass(span1, 'main-text')
      const span2 = this.renderer.createElement('span');
      this.renderer.addClass(span2, 'secondary-text');
      this.renderer.appendChild(span1, mainText);
      this.renderer.appendChild(span2, secondaryText);
      this.renderer.appendChild(options, span1);
      this.renderer.appendChild(options, span2);
      this.renderer.appendChild(dropdownContainer, options);

    });

    this.dropdown = dropdownContainer;
  }

  clearDropdown(): void {
    const parent = this._el.parentNode;
    const children = parent.children;
    if(children.length > 1){
      parent.removeChild(children[1]);
    }
  }

  onOptionSelected(option: any): void {

    this.userCommonService.getGoogleMapLatLng(option.placeId).subscribe(response => {
        const placeObj = {
          name: option.description,
          address: option.description,
          lat: response.results[0].geometry.location.lat,
          lng: response.results[0].geometry.location.lng,
          id: this._el.id,
          postalCode: this.getZipCode(response.results[0])
        };
        this.invokeEvent(placeObj);
        (this._el as HTMLInputElement).value = option.description;
        this.clearDropdown();

    });
  }

  getZipCode(result): string {
    let zipCode = '';
    for (const component of result.address_components) {
      if (component.types.includes('postal_code')) {
        zipCode = component.short_name;
      }
    }
    return zipCode;
  }

  ngOnChanges() {

  }

  invokeEvent(place: object) {
    this.setAddress.emit(place);
  }
}


// ************************** Google Search API Call From FrontEnd  ***********************************

// import { AppSettings } from './../app.settings';
// import { Directive, ElementRef, EventEmitter, Output, Input, OnChanges } from '@angular/core';
// declare const google: any;
// @Directive({
//   selector: '[appSearchLocation]'
// })
// export class SearchLocationDirective implements OnChanges {
//   @Output() setAddress: EventEmitter<any> = new EventEmitter();
//   @Input() onlyCity: Boolean = false;
//   private _el: HTMLElement;
//   autocomplete: any;
//   constructor(el: ElementRef) {
//     this._el = el.nativeElement;
//     const input = this._el;
//     this.autocomplete = new google.maps.places.Autocomplete(input, {});
//     // this.autocomplete.setComponentRestrictions(
//     //   { 'country': AppSettings.SUPPORTED_COUNTRY });
//     google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
//       const place = this.autocomplete.getPlace();
//       try {
//         const placeObj = {
//           'name': place.name,
//           'address': input['value'],
//           'lat': place.geometry.location.lat(),
//           'lng': place.geometry.location.lng(),
//           'id': input.id
//         };
//         this.invokeEvent(placeObj);
//       } catch (ex) {
//         console.warn(ex);
//       }

//     });

//   }

//   ngOnChanges() {
//     if (this.onlyCity) {
//       this.autocomplete.setOptions({ types: ['(cities)'] });
//     }
//   }
//   invokeEvent(place: Object) {
//     this.setAddress.emit(place);
//   }
// }
